//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Common = require('@/tbs/model/to/Common')
const ClassFunc = require('@/tbs/util/ClassFunc')

/**
 * The Player class works as the player translator.
 */
const tbs_model_to_Invitation = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Common, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_Invitation.prototype = {
    'invite-label': '未入驻激活 | 立即邀请',
    'member-invite-title': '邀请$name成为[$role]',
    'match-signup-top': '赛事',
    'match-signup-bottom': '报名',
    'team-registration-top': '球队',
    'team-registration-bottom': '注册',
    'match-schedule-top': '赛程',
    'match-schedule-bottom': '榜单',
    'match-notification-top': '赛事',
    'match-notification-bottom': '通知',
    'live-broadcast-top': '直播',
    'live-broadcast-bottom': '镜头',
    'sports-insurance-top': '运动',
    'sports-insurance-bottom': '保险',
    'invite-member-as-role': '邀请$name成为[$role]',
    'join-us': '立即加入',
    'welcome-title': '成功成为[$role]',
    'welcome-organization': '[$organization]',
    'download': '下载',
    'download-app-title': '斑马邦 · 开始赛事管理',
    'feature-item-org': '协会注册报名',
    'feature-item-live': '智能直播实况',
    'feature-item-fee': '赛事报名收费',
    'feature-item-stats': '数据分析统计',
    'feature-item-schedule': '赛程积分榜单',
    'feature-item-insurance': '赛事定制保险',
    'download-app-label': '赛事管理需下载斑马邦APP',
    'download-now': '立即下载',
}

//--------------------------------------------------
// extends the Common
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_Invitation, Common);

module.exports = tbs_model_to_Invitation